const wheelListenerOptions = { passive: false };
const guardedInputs = new WeakSet();

function isNumberInput(target) {
  return (
    target instanceof HTMLInputElement &&
    target.type === "number" &&
    !target.disabled &&
    !target.readOnly
  );
}

function wheelPixels(event) {
  let x = event.deltaX;
  let y = event.deltaY;

  if (event.deltaMode === WheelEvent.DOM_DELTA_LINE) {
    x *= 16;
    y *= 16;
  } else if (event.deltaMode === WheelEvent.DOM_DELTA_PAGE) {
    x *= window.innerWidth;
    y *= window.innerHeight;
  }

  return { x, y };
}

function getScrollableParent(node) {
  let parent = node.parentElement;

  while (parent) {
    const style = window.getComputedStyle(parent);
    const scrollsY =
      (style.overflowY === "auto" ||
        style.overflowY === "scroll" ||
        style.overflowY === "overlay") &&
      parent.scrollHeight > parent.clientHeight;
    const scrollsX =
      (style.overflowX === "auto" ||
        style.overflowX === "scroll" ||
        style.overflowX === "overlay") &&
      parent.scrollWidth > parent.clientWidth;

    if (scrollsY || scrollsX) {
      return parent;
    }

    parent = parent.parentElement;
  }

  return document.scrollingElement || document.documentElement;
}

const isSafari =
  typeof navigator !== "undefined" &&
  /safari/i.test(navigator.userAgent) &&
  !/chrome|chromium|crios|android/i.test(navigator.userAgent);

function handleNumberInputWheel(event) {
  const target = event.currentTarget;

  if (!(target instanceof HTMLInputElement) || document.activeElement !== target) {
    return;
  }

  event.preventDefault();

  if (isSafari) {
    target.blur();
    return;
  }

  const { x, y } = wheelPixels(event);
  const scroller = getScrollableParent(target);

  if (
    scroller === document.scrollingElement ||
    scroller === document.documentElement ||
    scroller === document.body
  ) {
    window.scrollBy(x, y);
    return;
  }

  scroller.scrollBy({ top: y, left: x });
}

function guardInput(target) {
  if (!isNumberInput(target) || guardedInputs.has(target)) {
    return;
  }

  target.addEventListener("wheel", handleNumberInputWheel, wheelListenerOptions);
  guardedInputs.add(target);
}

function releaseInput(target) {
  if (!guardedInputs.has(target)) {
    return;
  }

  target.removeEventListener("wheel", handleNumberInputWheel);
  guardedInputs.delete(target);
}

export function installNumberInputWheelGuard() {
  document.addEventListener("focusin", (event) => {
    guardInput(event.target);
  });
  document.addEventListener("focusout", (event) => {
    releaseInput(event.target);
  });

  guardInput(document.activeElement);
}
